/** @jsx h */
import { h } from 'preact'

const SafetyQuality = () => (
  <svg xmlnsXlink='http://www.w3.org/1999/xlink' width={28} height={32}>
    <defs>
      <path id='a' d='M0 .521h8.279v7.752H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(2 21.173)'>
        <mask id='b' fill='#fff'>
          <use xlinkHref='#a' />
        </mask>
        <path
          fill='#2F3A4A'
          d='M7.42 3.79L5.644 6.865 4.142 4.86a.505.505 0 0 0-.341-.197l-2.487-.297L3.259.996A2.889 2.889 0 0 1 2.378.52L.067 4.523a.5.5 0 0 0 .374.746l3.029.362 1.826 2.441a.5.5 0 0 0 .834-.049L8.279 4.3a2.816 2.816 0 0 1-.86-.51'
          mask='url(#b)'
        />
      </g>
      <path
        fill='#2F3A4A'
        d='M18.89 25.244a2.811 2.811 0 0 1-.938.362l.78 2.91-2.48-.357a.502.502 0 0 0-.38.102l-1.97 1.55-1.209-4.513a2.92 2.92 0 0 1-.947.33l1.386 5.174a.5.5 0 0 0 .793.262l2.396-1.885 3.02.435a.5.5 0 0 0 .552-.625l-1.003-3.745zM8.5 2.722c-.193 0-.339.133-.373.339L7.59 6.375l-3.172 1.01a.4.4 0 0 0-.249.21.412.412 0 0 0 .005.336l1.32 3.079-2.125 2.579a.41.41 0 0 0-.098.32c.016.109.08.207.181.275l2.76 1.87-.408 3.33a.408.408 0 0 0 .089.324c.05.058.141.127.294.13l3.327.067 1.441 3.027c.106.222.352.299.558.168l2.836-1.762 2.835 1.762c.208.129.452.054.559-.17l1.441-3.025 3.326-.067a.387.387 0 0 0 .293-.13.412.412 0 0 0 .09-.324l-.408-3.33 2.761-1.87a.404.404 0 0 0 .18-.276.411.411 0 0 0-.097-.32l-2.124-2.578 1.318-3.08a.407.407 0 0 0 .005-.335.4.4 0 0 0-.249-.21l-3.172-1.01-.537-3.313c-.04-.247-.247-.391-.492-.323l-3.211.883-2.227-2.497a.38.38 0 0 0-.583 0L11.83 3.623l-3.212-.884a.436.436 0 0 0-.118-.016m2.796 21.444a1.376 1.376 0 0 1-1.244-.804l-1.176-2.47-2.709-.054a1.383 1.383 0 0 1-1.029-.474 1.399 1.399 0 0 1-.327-1.1l.334-2.725-2.254-1.527a1.391 1.391 0 0 1-.61-.961 1.4 1.4 0 0 1 .317-1.1l1.736-2.107-1.079-2.52a1.387 1.387 0 0 1 .86-1.893l2.586-.823.439-2.706a1.388 1.388 0 0 1 1.743-1.128l2.614.719L13.312.459a1.4 1.4 0 0 1 2.074 0l1.815 2.034 2.612-.72a1.387 1.387 0 0 1 1.743 1.129l.44 2.706 2.586.824c.387.123.691.388.855.746.165.36.167.769.006 1.147l-1.08 2.519 1.736 2.109c.261.314.373.704.318 1.096a1.395 1.395 0 0 1-.61.963l-2.256 1.527.334 2.725c.05.41-.066.8-.326 1.1a1.383 1.383 0 0 1-1.028.474l-2.71.055-1.176 2.469c-.353.738-1.294 1.02-1.988.588l-2.308-1.434-2.308 1.434a1.417 1.417 0 0 1-.745.216'
      />
      <path
        fill='#2F3A4A'
        d='M12.571 15.867l-3.91-3.909a.5.5 0 0 1 .707-.707l3.203 3.202 6.757-6.758a.5.5 0 0 1 .707.707l-7.464 7.465z'
      />
    </g>
  </svg>
)

export default SafetyQuality
